import { useEffect, useState } from 'react';

const QUERY = '(min-width: 900px)';

function matches() {
  try {
    return window.matchMedia(QUERY).matches;
  } catch (e) {
    return true;
  }
}

// True on wide screens; follows window resizes and rotation.
export function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(matches);
  useEffect(() => {
    let media;
    try {
      media = window.matchMedia(QUERY);
    } catch (e) {
      return undefined;
    }
    const onChange = () => setIsDesktop(media.matches);
    media.addEventListener ? media.addEventListener('change', onChange) : media.addListener(onChange);
    return () => (media.removeEventListener ? media.removeEventListener('change', onChange) : media.removeListener(onChange));
  }, []);
  return isDesktop;
}
